// this enum needs to match the enum in the postgres Ask Data Mode column in sites table
export enum AskDataMode {
    ENABLED_BY_DEFAULT = 'enabled_by_default',
    DISABLED_BY_DEFAULT = 'disabled_by_default',
    DISABLED_ALWAYS = 'disabled_always',
}

export function AskDataModeFromString(val: string): AskDataMode {
  if ((Object as any).values(AskDataMode).includes(val)) {
    return val as AskDataMode;
  }
  else {
    return AskDataMode.ENABLED_BY_DEFAULT;
  }
}
